<!--
  O mesmo que temos hoje
  Conteúdo será revisado posteriormente
  Tirar última frase em negrito da página de educ. infantil
-->
<template>
  <section>
    <h3>
      <a href="/institucional/espaco-fisico">
        <v-icon>domain</v-icon>Espaço Físico
      </a>
    </h3>
    <p style="margin:5px 0 0 0">
      <a href="/institucional/espaco-fisico">
        <img
          :src="$store.getters.fotoPorSegmento(segmento)"
          alt="Foto segmento"
          style="width:100%;"
        >
      </a>
    </p>
    <p>A Escola Engenho possui uma estrutura incrível capaz de receber com qualidade a todos os seus estudantes.</p>
    <p style="text-align:right !important;">
      <v-btn
        href="/institucional/espaco-fisico"
        small
        depressed
        outline
        round
        color="primary"
      >ver mais</v-btn>
    </p>
  </section>
</template>

<script>
export default {
  props: { segmento: Number },
  data: () => ({})
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



